module.exports = __webpack_public_path__ + "assets/img/tool_ip.be7de2db.png";